// extracted by mini-css-extract-plugin
module.exports = {"container":"BlueTextTeaser__container","link":"BlueTextTeaser__link","icon":"BlueTextTeaser__icon","cta":"BlueTextTeaser__cta","headWithIcon":"BlueTextTeaser__headWithIcon"};